import { BitfStore } from '@bitf/core/models/bitf-store.model';
import { User } from '@models';
import { FsStore } from '@models';
import { EFsType, EApiCallStateNames, EFsContentType } from '@enums';
import { IFsConfiguration } from '@web/shared/components/file-system/fs-configuration.interface';

// NOTE: default values must be defined in the StoreService, not in the model
// (otherwise the default here will override the super Object.assign())
export class Store extends BitfStore {
  user: User;
  fsStore: { [key: string]: FsStore } = {};

  constructor(storeData: Store) {
    super(storeData);
  }

  getFs(configuration: IFsConfiguration): FsStore {
    const fsStore: FsStore = this.fsStore[configuration.name];
    if (fsStore) {
      return fsStore;
    } else {
      this.fsStore[configuration.name] = new FsStore(configuration);
      return this.fsStore[configuration.name];
    }
  }
}
